import AppWarn from './errors/app-warns'
import http from './webhook/httpconfig'
import { cancelHTTPRequests } from '@/services/utils'
import { generateHeaders } from './webhook/webhook'

export async function getVersionConfig() {
  let versionConfig = ''
  try {
    const response = await http.request({
      method: 'get',
      url: `/api/version`,
      headers: {
        'Cache-Control': 'no-cache',
        ...generateHeaders()
      },
      cancelToken: cancelHTTPRequests()
    })
    versionConfig = response.data?.version;
  } catch (err) {
    throw new AppWarn({name: 'Get Version', message:`Error while fetching version. ${err.message}`})
  }
  return versionConfig
}

